








import { defineComponent, ref, computed } from '@nuxtjs/composition-api';
import { useResizeObserver } from '@vueuse/core';
import { PRODUCT_WINE_BAR_COLORS } from '~/constants';
import { getProductColorFromType } from '~/utils/modules/products';

export default defineComponent({
  props: {
    wineType: {
      type: String,
      required: true,
    },
    point: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const wineBarGraph = ref<HTMLDivElement>();
    const clientWidth = ref(0);
    const pointWidth = 20;
    const color = computed(() => getProductColorFromType(props.wineType));

    const barWidth = computed(() => {
      if (props.point === 1) {
        return '10%';
      }

      if (props.point === 5) {
        return `calc(100% - ${pointWidth}px`;
      }

      return `calc(${(props.point / 5) * 100 - 10}% - ${pointWidth / 2}px )`;
    });
    const textColorClass = computed(() => {
      return `text-${color.value}`;
    });
    const gradientColor = computed(() => {
      const colors = PRODUCT_WINE_BAR_COLORS[color.value];

      if (!colors || !wineBarGraph.value) {
        return;
      }

      return `no-repeat left/${clientWidth.value}px linear-gradient(to right, ${colors.from} 50%, ${colors.to})`;
    });

    useResizeObserver(wineBarGraph, (entries) => {
      const target = entries[0]?.target;

      if (!(target instanceof HTMLDivElement)) return;
      clientWidth.value = target.clientWidth;
    });

    return {
      props,
      wineBarGraph,
      barWidth,
      textColorClass,
      gradientColor,
    };
  },
});
